import React from 'react'
import { AvatarProps } from 'antd/lib/avatar'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { Gender } from 'src/types'

import * as CSS from './styles'

export enum AvatarColorFlag {
  GREEN = 'green',
  RED = 'red',
  YELLOW = 'yellow'
}

type Props = AvatarProps & {
  colorFlag?: AvatarColorFlag
  gender: Gender
  name: string
}

function getAvatarIcon(color?: AvatarColorFlag, t?: TFunction) {
  switch (color) {
    case AvatarColorFlag.GREEN:
      return (
        <CSS.WrapIcon
          theme="twoTone"
          title={t('common.status.hierarquia.approved')}
          twoToneColor="#52c41a"
          type="check-circle"
        />
      )
    case AvatarColorFlag.RED:
      return (
        <CSS.WrapIcon
          theme="twoTone"
          title={t('common.status.hierarquia.reproved')}
          twoToneColor="#ff4d4f"
          type="close-circle"
        />
      )
    case AvatarColorFlag.YELLOW:
      return (
        <CSS.WrapIcon
          theme="twoTone"
          title={t('common.status.hierarquia.pending')}
          twoToneColor="#FFC107"
          type="check-circle"
        />
      )
    default:
      return null
  }
}

export default function UserAvatar({
  colorFlag,
  gender,
  name,
  ...props
}: Props) {
  const { t } = useTranslation()
  const icon = getAvatarIcon(colorFlag, t)
  return (
    <CSS.Container>
      {icon}
      <CSS.WrapUserAvatar gender={gender} {...props}>
        {name
          .split(/[^A-Z]{1,}/)
          .reduce(
            (response, word, index, array) =>
              (response += [0, 1, array.length - 2].includes(index)
                ? word.slice(0, 1).toUpperCase()
                : ''),
            ''
          )}
      </CSS.WrapUserAvatar>
    </CSS.Container>
  )
}
